import {
    CoreConfigParent,
    CoreConfigSection,
} from '../../../../interfaces/examiner/CoreConfig'

export function parseDayMonthValue(value: string): Date | null {
    if (!value || !value.trim()) return null
    const currentYear = new Date().getFullYear()
    const match = /^(\d{2})-(\d{2})$/.exec(value.trim())
    if (!match) {
        const iso = new Date(value.trim())
        if (Number.isNaN(iso.getTime())) return null
        return new Date(currentYear, iso.getMonth(), iso.getDate())
    }
    const day = parseInt(match[1], 10)
    const month = parseInt(match[2], 10)
    if (month < 1 || month > 12 || day < 1 || day > 31) return null
    const date = new Date(currentYear, month - 1, day)
    if (date.getMonth() !== month - 1 || date.getDate() !== day) return null
    return date
}

export function formatDayMonthValue(date: Date | null): string {
    if (!date || Number.isNaN(date.getTime())) return ''
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    return `${day}-${month}`
}

export function parseDateValue(value: string): Date | null {
    if (!value || !value.trim()) return null
    const date = new Date(value)
    return Number.isNaN(date.getTime()) ? null : date
}

export function formatDateValue(date: Date | null): string {
    if (!date || Number.isNaN(date.getTime())) return ''
    return date.toISOString().slice(0, 10)
}

export function collectValues(parents: CoreConfigParent[]): Record<string, string> {
    const values: Record<string, string> = {}
    parents.forEach((parent) => {
        parent.sections.forEach((section) => {
            section.groups.forEach((group) => {
                group.fields.forEach((field) => {
                    if (field.type === 'action' || field.type === 'readonly') return
                    values[field.key] = field.value
                })
            })
        })
    })
    return values
}

export function updateParentsField(
  parents: CoreConfigParent[],
  key: string,
  value: string
): CoreConfigParent[] {
    return parents.map((parent) => ({
        ...parent,
        sections: parent.sections.map((section) => ({
            ...section,
            groups: section.groups.map((group) => ({
                ...group,
                fields: group.fields.map((field) =>
                  field.key === key ? { ...field, value } : field
                ),
            })),
        })),
    }))
}

export function findSection(
  parents: CoreConfigParent[],
  sectionId: string
): CoreConfigSection | null {
    for (const parent of parents) {
        const section = parent.sections.find((item) => item.id === sectionId)
        if (section) return section
    }
    return null
}

export function buildInitialExpandedParents(
  parents: CoreConfigParent[]
): Record<string, boolean> {
    const expanded: Record<string, boolean> = {}
    parents.forEach((parent, index) => {
        expanded[parent.id] = index === 0
    })
    return expanded
}

export function buildInitialExpandedGroups(
  parents: CoreConfigParent[]
): Record<string, boolean> {
    const expanded: Record<string, boolean> = {}
    parents.forEach((parent) => {
        parent.sections.forEach((section) => {
            section.groups.forEach((group, index) => {
                expanded[group.id] = index === 0
            })
        })
    })
    return expanded
}
